import { Box, Button, CircularProgress, Grid, Stack } from '@mui/material'
import { ClientData } from '../atoms/clientConfigState'
import ClientDetails from './ClientDetails'
import ClientsService from '../service/clients'
import ConfigureWotcSettings from './ConfigureWotcSettings'
import DisableWotcConfirmDialog from './DisableWotcConfirmDialog'
import { FormEvent } from 'react'
import { GridLabel } from './ClientConfigToolStyles'
import { Heading1 } from './ClientConfigToolStyles'
import Notification from '../util/Notification'
import { PageLoaderContainer } from './ClientConfigToolStyles'
import React from 'react'
import WotcApplicantService from '../service/wotcapplicant'
import clientConfigState from '../atoms/clientConfigState'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import { useParams } from 'react-router-dom'
import { useRecoilValue } from 'recoil'
import { useSetRecoilState } from 'recoil'
import { useState } from 'react'
import wotcConfigState from '../atoms/wotcConfigState'


function ConfigureWotcPage() {

  const navigate = useNavigate()
  const params = useParams()
  const location = useLocation()

  const updateClientState = useSetRecoilState(clientConfigState)
  const clientState = useRecoilValue(clientConfigState)
  const updateWotcConfigState = useSetRecoilState(wotcConfigState)
  const wotcState = useRecoilValue(wotcConfigState)

  const [showDisableDialog, setShowDisableDialog] = useState(false)
  const [submitting, setSubmitting] = useState(false)
  const [linkCredentialsEnabled, setLinkCredentialsEnabled] = useState(false)
  const [sourceTrUuid, setSourceTrUuid] = useState('')

  const { data } = clientState
  const { cctConfig, wotcConfig } = wotcState
  const [pageLoader, setPageLoader] = useState(true)

  const returnToSearch = () => {
    updateClientState({ ...clientState, data: { ...clientState.data, client_id: 0 } })
    navigate('/client-config-tool')
  }

  useEffect(() => {
    const client = location.state ? location.state.client : null
    if (client && client.syncID) {
      WotcApplicantService.getWotcClient(client.syncID).then(
        (response) => {
          
          const wotcConfigResponse = {
            active: response.active,
            clientId: response.clientId,
            legacyClientId: response.legacyClientId ? response.legacyClientId : client.client_id,
            linkedFromClientId: response.linkedFromClientId || undefined,
            locations:response.locations ? response.locations : [],
            marketIntegration: response.marketIntegration,
            organizationCode: response.organizationCode || '',
            providerName: response.providerName,
            selectedOrganizationCode: '',
            selectedProvider: '',
          }

          if (response.linkedFromClientId) {
            setLinkCredentialsEnabled(true)
            setSourceTrUuid(response.linkedFromClientId)
          }

          updateWotcConfigState({
            ...wotcState,
            wotcConfig: {
              ...wotcConfig,
              ...wotcConfigResponse
            }
          })

          updateClientState({
            ...clientState,
            data: {
              ...data,
              ...client
            },
          })
        }
      ).finally(() => {
        setPageLoader(false)
      })
    } else {

      const { clientId } = params
      if (clientId) {

        ClientsService
          .getAllClients()
          .then(function (result) {
            const clientData =  result.find((clt:ClientData) => clt.client_id === Number.parseInt(clientId))
            updateClientState({
              ...clientState,
              data: {
                ...data,
                ...clientData,
                value: `${clientData.client_id}`,
              },
            })

            if (clientData && clientData.syncID) {
              WotcApplicantService.getWotcClient(clientData.syncID).then(
                (response) => {

                  const wotcConfigResponse = {
                    active: response.active,
                    clientId: response.clientId,
                    legacyClientId: response.legacyClientId ? response.legacyClientId : data.client_id,
                    linkedFromClientId: response.linkedFromClientId || undefined,
                    locations:response.locations ? response.locations : [],
                    marketIntegration: response.marketIntegration,
                    organizationCode: response.organizationCode || '',
                    providerName: response.providerName,
                    selectedOrganizationCode: '',
                    selectedProvider: '',
                  }

                  if (response.linkedFromClientId) {
                    setLinkCredentialsEnabled(true)
                    setSourceTrUuid(response.linkedFromClientId)
                  }

                  updateWotcConfigState({
                    ...wotcState,
                    wotcConfig: {
                      ...wotcConfig,
                      ...wotcConfigResponse
                    }
                  })
                }
              )
            }
          })
          .catch(() => {
            navigate('/client-config-tool', { state: { error: 'The URL you’ve provided does not exist. Please try searching for the client by name.' } })
          })
          .finally(() => {
            setPageLoader(false)
          })
      }
    }
  }, [wotcState.wotcConfig.providerName])

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault()

    if (wotcConfig.active && (wotcConfig.selectedProvider === 'SYNERGI' || wotcConfig.selectedProvider === 'EH') && wotcConfig.selectedOrganizationCode === '') {
      updateWotcConfigState({
        ...wotcState,
        cctConfig: {
          ...cctConfig,
          orgError: true
        },
      })
      return
    }

    if (wotcConfig.active && (!wotcConfig.selectedProvider || wotcConfig.selectedProvider === 'none')) {
      updateWotcConfigState({
        ...wotcState,
        cctConfig: {
          ...cctConfig,          
          vendorListError: true
        },
      })
      return
    }


    setSubmitting(true)
    const request = WotcApplicantService.saveWotcConfig(wotcConfig.clientId, wotcConfig)
    request
      .then(async (response) => {
        if (linkCredentialsEnabled && sourceTrUuid) {
          await WotcApplicantService.linkCredentials(wotcConfig.clientId, sourceTrUuid)
        }
        updateWotcConfigState({
          ...wotcState,
          cctConfig: {
            ...cctConfig,
            alertMessage: wotcConfig.active ? 'Your recent changes have been saved successfully' : 'WOTC configurations have been disabled',
            alertSeverity: 'success',
            alertTitle: 'Success',
            isUpdate: true,
            orgError: false,
            showAlert: true,
            vendorListError: false,
          },
          wotcConfig: {
            ...wotcConfig,
            ...response.data,
            legacyClientId: response.data.legacyClientId || data.client_id,
            locations: response.data.locations || [],
            organizationCode: response.data.organizationCode || '',
            selectedOrganizationCode: '',
            selectedProvider: '',
          },
        })
      })
      .catch(e => {
        const data = e?.response?.data
        const title = data?.message || data?.title || 'Unknown error'
        const message = data?.developerMessage || data?.detail || 'An unexpected error occurred while saving the WOTC configuration.'
        updateWotcConfigState({
          ...wotcState,
          cctConfig: {
            ...cctConfig,
            alertMessage: message,
            alertSeverity: 'error',
            alertTitle: `Error - ${title}`,
            showAlert: true,
          },
        })
      })
      .finally(() => {
        setSubmitting(false)
      })
   
  }

  if (pageLoader) {
    return (
      <PageLoaderContainer>
        <CircularProgress sx={{ marginBottom: '1.5rem' }} />
        <GridLabel>{'Loading the wotc configurations.'}</GridLabel>
        <GridLabel>{'This may take several seconds.'}</GridLabel>
      </PageLoaderContainer>
    )
  }

  return (
    <Box padding={3.75}>
      {cctConfig.showAlert
        && (
          <Notification
            autoHide={true}
            description={cctConfig.alertMessage}
            onClose={() => {
              updateWotcConfigState({
                ...wotcState, 
                cctConfig: {
                  ...cctConfig,
                  showAlert: false,
                }
              })
            }}
            severity={cctConfig.alertSeverity}
            title={cctConfig.alertTitle}
          />
        )
      }
      <Stack spacing={2.2}>
        <Heading1>Configure Client Settings</Heading1>
        <form onSubmit={handleSubmit}>
          <Stack spacing={3}>
            <ClientDetails client={data} />               
            <ConfigureWotcSettings
              cctConfig={cctConfig}
              linkCredentialsEnabled={linkCredentialsEnabled}
              setLinkCredentialsEnabled={setLinkCredentialsEnabled}
              setSourceTrUuid={setSourceTrUuid}
              sourceTrUuid={sourceTrUuid}
              wotcConfig={wotcConfig} />
            <Grid
              alignItems="flex-end"
              columnSpacing={3.8}
              container
              justifyContent="flex-end"
              paddingRight={1}
              rowSpacing={1}
            >
              <Grid item>
                <Button color="primary" onClick={returnToSearch}>
                  Return to search
                </Button>
              </Grid>
              <Grid item xs={1}>
                {wotcConfig.active
                  ? (
                    <Button
                      color="primary"
                      disabled={submitting}
                      endIcon={submitting ? <CircularProgress color='inherit' size={15} /> : null}
                      type={submitting ? 'button' : 'submit'}
                      variant="contained"
                    >
                      Save
                    </Button>
                  )
                  : (
                    <Button
                      color="primary"
                      disabled={wotcConfig.providerName ? submitting : true}
                      endIcon={submitting ? <CircularProgress color='inherit' size={15} /> : null}
                      onClick={() => submitting ? '' : setShowDisableDialog(true)}
                      variant="contained"
                    >
                      Save
                    </Button>
                  )
                }

                {showDisableDialog
                  && (
                    <DisableWotcConfirmDialog 
                      data-testid="cct-disable-dialog"
                      handleClose={() => setShowDisableDialog(false)}
                      handleSubmit={(event: FormEvent) => {
                        setShowDisableDialog(false)
                        handleSubmit(event)
                      }}
                      open={showDisableDialog} 
                    />
                  )
                }
              </Grid>
            </Grid>
          </Stack>
        </form>
      </Stack>
    </Box>
  )
}

export default ConfigureWotcPage